import service from "@/store/services/tax-groups-service";

export const state = () => ({
  list: {},
  taxGroup: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, taxGroup) => {
    state.taxGroup = taxGroup;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((taxGroup) => {
      commit("SET_RESOURCE", taxGroup);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((taxGroup) => {
      commit("SET_RESOURCE", taxGroup);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((taxGroup) => {
      commit("SET_RESOURCE", taxGroup);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  taxGroup: (state) => state.taxGroup,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((taxGroup) => ({
      id: taxGroup.id,
      name: `${taxGroup.name}`,
    }));
  },
};

const taxGroups = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default taxGroups;
